import { createFileRoute } from '@tanstack/react-router'
import { StubScreen } from '@/components/StubScreen'

export const Route = createFileRoute('/goals')({
  component: () => <StubScreen heading="Goals" />,
})
